// extracted by mini-css-extract-plugin
export default {"image-container":"image_image-container__6OUIA","image-skeleton":"image_image-skeleton__2qA8K","skeleton-loading":"image_skeleton-loading__KJdSB"};